<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  computed: {
    ...mapGetters("oidcStore", [
      "oidcIsAuthenticated",
      "oidcUser",
      "oidcAccessToken",
      "oidcAccessTokenExp",
      "oidcIdToken",
      "oidcIdTokenExp",
      "oidcRefreshToken",
      "oidcRefreshTokenExp",
      "oidcAuthenticationIsChecked",
      "oidcError",
    ]),
    hasAccess: function () {
      return this.oidcIsAuthenticated || this.$route.meta.isPublic;
    },
  },
  watch: {},
  methods: {
    ...mapActions("oidcStore", [
      "authenticateOidc", // Authenticates with redirect to sign in if not signed in
      "oidcSignInCallback", // Handles callback from authentication redirect. Has an optional url parameter
      "authenticateOidcSilent", // Authenticates if signed in. No redirect is made if not signed in
      "getOidcUser", // Get user from oidc-client storage and update it in vuex store. Returns a promise
      "signOutOidc", // Signs out user in open id provider
      "signOutOidcSilent", // Signs out user in open id provider using a hidden iframe
      "removeOidcUser", // Signs out user in vuex and browser storage, but not in open id provider
    ]),
    userLoaded: function () {
      console.log("the user loaded event in vuex-oidc");
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
        this.$message({
          type: "success",
          message: this.$t("app.refreshSuccess"),
        });
      });
    },
  },
  mounted() {
    window.addEventListener("vuexoidc:userLoaded", this.userLoaded);
  },
  destroyed() {
    window.removeEventListener("vuexoidc:userLoaded", this.userLoaded);
  },
};
</script>
<style lang="scss" scoped>
input[disabled],
input:disabled,
input.disabled,
textarea[disabled],
textarea:disabled,
textarea.disabled,
.el-radio__input.is-disabled + span.el-radio__label {
  -webkit-text-fill-color: #333;
  -webkit-opacity: 1;
  opacity: 1;
}
.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background-color: #333 !important;
}
.el-radio__input.is-checked+.el-radio__label{
  color: #119F7B;// #409eff;
}
html,
body,
#app {
  height: 100vh;
  position: relative;
  width: 100%;
}
.word-break {
  word-break: normal;
}
.el-table .cell {
  word-break: normal !important;
}
.el-table__empty-block {
  width: 100% !important;
}
.none-scroll-bar::-webkit-scrollbar {
  display: none;
}
.scroll-bar::-webkit-scrollbar {
  display: block;
}
.scroll-bar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll-bar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.3);
}
.scroll-bar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.clearfix::after {
  display: table;
  content: "";
  clear: both;
}
button {
  cursor: pointer;
}
// 自动换行
.lineFeed {
  white-space: normal;
  word-break: break-all;
  /*overflow:hidden;*/
}

</style>